import step6Image from '@/assets/tourguide/01001/step6.png'

export default [
  {
    hideArrow: true,
    target: 'header .v-toolbar__content',
    title: 'さらに商品を絞り込んでみましょう！',
    content: `<p>分類を選択すると、さらに細かく条件を指定して商品を絞り込むことができるようになります。</p>
<p>ご利用方法をご覧になる場合は、「次へ」ボタンをクリックしてください。</p>`,
  },
  {
    target: '#tour-01001-cat-step2',
    title: '中分類で商品を絞り込む',
    content: `<p>商品の中分類を選んで商品を絞り込むことができます。</p>`,
  },
  {
    target: '#tour-01001-cat-step3',
    title: '表面加工で絞り込む',
    content: `<p>商品の表面加工を選んで商品を絞り込むことができます。</p>
<p>表面加工は複数選択することができます。</p>`,
  },
  {
    target: '#tour-01001-cat-step4',
    title: '径で絞り込む',
    content: `<p>商品の「径」を選んで商品を絞り込むことができます。</p>
<p>径は複数選択することができます。</p>`,
  },
  {
    target: '#tour-01001-cat-step5',
    title: '長さで絞り込む',
    content: `<p>商品の長さを選んで商品を絞り込むことができます。</p>
<p>長さは複数選択することができます。</p>`,
  },
  {
    target: '#tour-01001-cat-step6',
    title: '在庫のあり／なしで絞り込む',
    content: `<p>在庫のあり／なしで商品を絞り込むことができます。</p>
<p>「在庫ありのみ表示」とした場合は在庫がある商品のみを絞り込むことができます。</p><img class="badge-bg" src="${step6Image}" style="width: 50%; margin-top: 20px" />`,
  },
]